import { ServicosMateriaisSecaoView } from "./view-servicos-materiais-secao";
import type { ServicosMateriaisSecaoProps } from "./types-servicos-materiais-secao";

export function ServicosMateriaisSecao(props: ServicosMateriaisSecaoProps) {
  return <ServicosMateriaisSecaoView {...props} />;
}

export { testIdsServicosMateriais } from "./servicos-materiais-secao.test-ids";
export type * from "./types-servicos-materiais-secao";
